import React, { useEffect, useState } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import { Button, Paper, Dialog, DialogActions, DialogContent, DialogTitle, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, IconButton, Checkbox, Autocomplete, CircularProgress, Tooltip } from "@mui/material";
import { globalGetService } from "../../../utils/globalApiServices";
import { checkApiStatus, numberWithCommas } from "../../../utils";
import { trackActivity } from "../../../utils/mixpanel";
import { PageLoader } from "../../../shared_elements";
import { regexConstants } from "../../../constants/regEx";
import { getEngineThrustApi } from "../apiService";
import { useSnackbar } from "notistack";

const AddThrustSplit = ({ toggleModalFn, addTrustSplit, mode,modeForm, selectedIndex, format,}) => {

    const [tableErrors, setTableErrors] = useState({});
    const [isLoading, setLoading] = useState(false);
    const [engineTrustList, setEngineTrustList] = useState(null)
    const [dropDownLoader, setDropDownLoader] = useState({ constant: false, user: false })
    const [rows, setRows] = useState(addTrustSplit?.data ? addTrustSplit?.data : []);
    const [prevValue, setPrevValue] = useState('')
    const { enqueueSnackbar } = useSnackbar()
  
    useEffect(() => {
        const incoming = addTrustSplit?.data;
        const addeddata = addTrustSplit?.data?.table
        if (!incoming) return;
        if (mode === 'edit' || mode === 'view') {
            const mappedRows = (addeddata ? addeddata : incoming?.thrust_splits)?.map(split => ({
                id: split?.id || null,
                engine_thrust_types: {
                    id: split?.engine_thrust_type_id || split?.engine_thrust_types?.id,
                    name: split?.name || split?.engine_thrust_types?.name,
                },
                hours: split?.hours,
                cycles: split?.cycles,
                current: split?.current_thrust || split?.current
            }));
            setRows(mappedRows);
            return;
        }
       if(mode === 'add' || modeForm === 'create'){
            if (Array.isArray(addeddata)) {
                 setRows(addeddata);
                     return;
                    }
            if (incoming?.operating_thrust) {
            setRows([
                {
                    engine_thrust_types: incoming?.operating_thrust,
                    hours: format === "Time Format" ? '0:0' : '0',
                    cycles: format === "Time Format" ? '0:0' : '0',
                    current: true
                }
            ]);
        }
       }
      
    }, [addTrustSplit?.data]);
   
    const getSelectedIds = () => {
        return rows
            .map(r => r?.engine_thrust_types?.id)
            .filter(Boolean);
    };

    const handleAddRow = () => {
        const incoming = addTrustSplit?.data;
        if (rows?.length === 0) {
            setRows([
                {
                    engine_thrust_types: incoming?.operating_thrust,
                    hours: format === "Time Format" ? '0:0' : '0',
                    cycles: format === "Time Format" ? '0:0' : '0',
                    current: true
                }
            ]);
        } else {
            setRows([
                ...rows,
                {
                    engine_thrust_types: null,
                    hours: format === "Time Format" ? '0:0' : '0',
                    cycles: format === "Time Format" ? '0:0' : '0',
                    current: false
                }
            ]);
        }
    };

    const handleCurrentChange = (selectedIndex, checked) => {

        const updated = rows.map((row, i) => ({
            ...row,
            current: i === selectedIndex ? checked : false
        }));

        setRows(updated);
    };

    useEffect(() => {
        getEngineTrustList();
    }, [])
    
    const getEngineTrustList = () => {
        setDropDownLoader(prev => ({ ...prev, user: true }));
        globalGetService(getEngineThrustApi(addTrustSplit?.data?.[0]?.engine_thrust_types?.id || addTrustSplit?.data?.operating_thrust?.id || addTrustSplit?.data?.engine_family_engine_type))
            .then(response => {
                setDropDownLoader(prev => ({ ...prev, user: false }));
                if (checkApiStatus(response)) {
                    setLoading(false);
                    setEngineTrustList(response?.data?.data);
                }
            })
    }

    const handleDeleteRow = (index) => {
        setRows(rows?.filter((_, i) => i !== index));
    };

    const handleChange = (index, key, value) => {
        const updated = [...rows];
        updated[index][key] = value;
        setRows(updated);
    };

    const onAddEditThrust = () => {
        let newErrors = {};

        if (!rows || rows?.length === 0) {
            enqueueSnackbar(
                "Please add at least one row item to proceed.",
                { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" } }
            );
            return;
        }

        const hasCurrent = rows?.some(row => row?.current === true);

        if (!hasCurrent) {
            enqueueSnackbar(
                "Please select Current thrust to proceed",
                { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" } }
            );
            return;
        }

        rows.forEach((row, index) => {
            const errors = {};
            if (!row.engine_thrust_types?.id) {
                errors.engine_thrust_types = "Please select Thrust type";
            }
            if (row.hours === "" || row.hours === null || row.hours === undefined) {
                errors.hours = "Please enter Hours";
            }
            if (row.cycles === "" || row.cycles === null || row.cycles === undefined) {
                errors.cycles = "Please enter Cycles";
            }
            if (Object.keys(errors).length > 0) {
                newErrors[index] = errors;
            }
        });

        setTableErrors(newErrors);
        if (Object.keys(newErrors).length > 0) return;
        toggleModalFn(rows, selectedIndex);
    };

    const onRestErrorKey = (rowIndex, key) => {
        setTableErrors((prev) => ({
            ...prev,
            [rowIndex]: { ...prev[rowIndex], [key]: "" }
        }));
    };

    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Add Thrust Split`, page_type: page_type, })
    }

    return (
        <Dialog maxWidth="md" fullWidth open scroll="paper">
            <DialogTitle className="dialog-header" sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }} >
                <span>Thrust Split</span>
                {mode !== 'view' ? <Button variant="outlined" size="small" onClick={handleAddRow} >
                    + ADD NEW ROW
                </Button> : null }
            </DialogTitle>
            <DialogContent dividers>
                <TableContainer className="lease-detail-table" component={Paper}>
                    <Table className="mui-table-format" >
                        <TableHead>
                            <TableRow>
                                <TableCell><b>Engine Thrust Type *</b></TableCell>
                                <TableCell width={150}><b>Hours *</b></TableCell>
                                <TableCell width={150}><b>Cycles *</b></TableCell>
                                <TableCell width={120} align="center"><b>Current Thrust</b></TableCell>
                                {mode !== 'view' ? <TableCell width={40} align="right"><b>Action</b></TableCell> : null}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows?.length > 0 && rows?.map((row, index) => (
                                <TableRow key={index}>
                                    <TableCell width="30%">
                                        <Autocomplete
                                            size="small"
                                            options={engineTrustList?.engineTypes?.filter(item => !getSelectedIds().includes(item?.id)) || []}
                                            value={row?.engine_thrust_types || ""}
                                            getOptionLabel={(o) => o?.name || ""}
                                            isOptionEqualToValue={(o, v) => o.id === v.id}
                                            onChange={(e, val) => handleChange(index, "engine_thrust_types", val)}
                                            loading={dropDownLoader?.user}
                                            disabled={dropDownLoader?.user || mode === 'view'}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    error={Boolean(tableErrors[index]?.engine_thrust_types)}
                                                    helperText={tableErrors[index]?.engine_thrust_types}
                                                    onFocus={() => onRestErrorKey(index, "engine_thrust_types")}
                                                    slotProps={{
                                                        inputLabel: { shrink: true, },
                                                        input: {
                                                            ...params?.InputProps, endAdornment: (<>{dropDownLoader?.user ? (<CircularProgress color="inherit" size={20} />) : null}
                                                                {params?.InputProps?.endAdornment}
                                                            </>
                                                            )
                                                        }
                                                    }}
                                                />
                                            )}

                                        />

                                    </TableCell>
                                    <TableCell>
                                        <TextField
                                            size="small"
                                            value={mode === 'view' && row?.hours !== '' && row?.hours !== null && row?.hours !== undefined ? (format === 'Time Format' ? row?.hours : numberWithCommas(row?.hours)) : (row?.hours ?? "")}
                                            onChange={(e) => {
                                                const inputValue = e.target.value;
                                                if (format === "Time Format") {
                                                    const allowedPattern = /^(\d{0,5})(:)?([0-5]?[0-9]?)?$/;
                                                    if (allowedPattern.test(inputValue) || inputValue === '') {
                                                        setPrevValue(inputValue);
                                                        handleChange(index, "hours", inputValue);
                                                    }
                                                } else {
                                                   if (regexConstants?.decimalnodotstart?.test(inputValue)) { handleChange(index, "hours", inputValue); }
                                                }
                                            }}
                                            error={Boolean(tableErrors[index]?.hours)}
                                            helperText={tableErrors[index]?.hours}
                                            placeholder={format === "Time Format" && "HH:MM"}
                                            onFocus={() => onRestErrorKey(index, "hours")}
                                            slotProps={{ inputLabel: { shrink: true },htmlInput: { maxLength: 8 }  }}
                                            fullWidth
                                            disabled={mode === 'view'}
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <TextField
                                            size="small"
                                            value={mode === 'view' && row?.cycles !== '' && row?.cycles !== null && row?.cycles !== undefined ? (format === 'Time Format' ? row?.cycles : numberWithCommas(row?.cycles)) : (row?.cycles ?? "")}
                                            onChange={(e) => {
                                                const inputValue = e.target.value;
                                                if (format === "Time Format") {
                                                    const allowedPattern = /^(\d{0,5})(:)?([0-5]?[0-9]?)?$/;
                                                    if (allowedPattern.test(inputValue) || inputValue === '') {
                                                        setPrevValue(inputValue);
                                                        handleChange(index, "cycles", inputValue);
                                                    }
                                                } else {
                                                    if (regexConstants?.decimalnodotstart?.test(inputValue)) { handleChange(index, "cycles", inputValue); }
                                                }
                                            }}
                                           
                                            error={Boolean(tableErrors[index]?.cycles)}
                                            helperText={tableErrors[index]?.cycles}
                                            placeholder={format === "Time Format" && "HH:MM"}
                                            onFocus={() => onRestErrorKey(index, "cycles")}
                                            slotProps={{ inputLabel: { shrink: true } , htmlInput: { maxLength: 8 }  }}
                                            fullWidth
                                            disabled={mode === 'view'}
                                        />
                                    </TableCell>
                                    <TableCell align="center">
                                        <Checkbox
                                            size="small"
                                            checked={row?.current || ""}
                                            onChange={(e) => handleCurrentChange(index, e.target.checked)}
                                            disabled={mode === 'view'}
                                        />

                                    </TableCell>
                                    {mode !== 'view' ? <TableCell align="right">
                                        <Tooltip title='Remove' arrow>
                                            <IconButton onClick={() => handleDeleteRow(index)}>
                                                <DeleteIcon fontSize='small' color="error" />
                                            </IconButton>
                                        </Tooltip>
                                    </TableCell> : null }
                                </TableRow>
                            ))}
                            {rows?.length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={5} align="center">
                                        No Data Found
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
            <DialogActions sx={{ marginRight: "15px" }}>
                <Button variant="outlined" size='small' onClick={() => toggleModalFn(null)}>
                    Cancel
                </Button>
                {mode !== 'view' ? <Button variant='contained' className='btn-primary' size='small' onClick={() => { handleItemClicked('Save Button'); onAddEditThrust(); }} >
                    {isLoading ? <CircularProgress color='inherit' size={25} /> : "Continue"}
                </Button> : null }
            </DialogActions>
            {isLoading ? <PageLoader /> : null}
        </Dialog>
    );
};

export default AddThrustSplit;
